import { render, staticRenderFns } from "./staff_detaill.vue?vue&type=template&id=52d9f8b7&scoped=true&"
import script from "./staff_detaill.vue?vue&type=script&lang=ts&"
export * from "./staff_detaill.vue?vue&type=script&lang=ts&"
import style0 from "./staff_detaill.vue?vue&type=style&index=0&id=52d9f8b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9f8b7",
  null
  
)

export default component.exports